import { atom } from 'recoil'

import { capacitorPreferencesEffect } from '@/capacitor/recoil/capacitor-preferences-effect'
import { IDLE_TIMEOUT, SESSION_DURATION, WARNING_PERCENTAGE } from '@/modules/core/constants/idle-timer.constants'

export type DebugSettings = {
  /** Timeout in ms, if reached the user will get locked */
  idleTimeout: number
  /** Duration in ms, this will be used to auto logout the user */
  sessionDuration: number
  /** Percentage of the idleTimeout, when reached the user will get a warning */
  warningPercentage: number
}

const debugSettingsAtom = atom<DebugSettings>({
  key: '@app/debug-settings',
  default: {
    // default 30 minutes
    idleTimeout: IDLE_TIMEOUT,
    // default 3 months
    sessionDuration: SESSION_DURATION,
    // default 10%
    warningPercentage: WARNING_PERCENTAGE,
  },
  effects: [capacitorPreferencesEffect('@app/debug-settings')],
})

export { debugSettingsAtom }
